module.exports = __webpack_public_path__ + "img/1512239834.a943b0ec.jpg";